export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14729.dea25033.jpg";